import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';

/**
 * Résout un slug en establishment_id via la vue publique anonymisée.
 * Si establishmentId est fourni directement, retourne celui-ci sans requête.
 * Cache: 10 min (le slug d'un établissement change rarement).
 */
export function useResolvedEstablishmentId(
  establishmentId?: string | null,
  slug?: string | null
) {
  const { data, isLoading } = useQuery({
    queryKey: ['resolved-establishment-id', establishmentId ?? null, slug ?? null],
    queryFn: async (): Promise<string | null> => {
      if (establishmentId) return establishmentId;
      if (!slug) return null;

      const { data, error } = await supabasePublic
        .from('public_establishments')
        .select('id')
        .eq('slug', slug)
        .single();

      if (error) {
        console.error('[useResolvedEstablishmentId] Error resolving slug:', error);
        return null;
      }
      return data?.id ?? null;
    },
    staleTime: 1000 * 60 * 10,
    enabled: Boolean(establishmentId || slug),
  });

  return {
    resolvedEstablishmentId: data ?? (establishmentId ?? null),
    isResolving: isLoading,
  };
}
